/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// MD12 — KD68200WHITE dzieci 250x353 mm
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Md12: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("PIERWSZY ALBUM");
  const [text2, setText2] = useState<string>("Leosia");
  const [text3, setText3] = useState<string>("Kubusiu, jak się pisze MIŁOŚĆ?");
  const [text4, setText4] = useState<string>(
    "Prosiaczku, MIŁOŚĆ się nie pisze,",
  );
  const [text5, setText5] = useState<string>("MIŁOŚĆ się czuje.");
  const text1BasicSize = 57;
  const text2BasicSize = 101;
  const text3BasicSize = 36;
  const text4BasicSize = 36;
  const text5BasicSize = 36;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "353mm"; // PDF height in mm
  const font1 = "Beryliumrg";
  const font2 = "AphroditeSlimPro";
  const maxWidth1 = 628;
  const maxWidth2 = 422;
  const maxWidth3 = 631;
  const maxWidth4 = 666;
  const maxWidth5 = 358;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) =>
    document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(
        adjustFontSize(
          text1,
          fontSizeText1,
          text1BasicSize,
          14,
          font1,
          maxWidth1,
        ),
      ),
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(
        adjustFontSize(
          text2,
          fontSizeText2,
          text2BasicSize,
          14,
          font2,
          maxWidth2,
        ),
      ),
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(
        adjustFontSize(
          text3,
          fontSizeText3,
          text3BasicSize,
          10,
          font1,
          maxWidth3,
        ),
      ),
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText4(
        adjustFontSize(
          text4,
          fontSizeText4,
          text4BasicSize,
          10,
          font1,
          maxWidth4,
        ),
      ),
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText5(
        adjustFontSize(
          text5,
          fontSizeText5,
          text5BasicSize,
          10,
          font1,
          maxWidth5,
        ),
      ),
    );
  }, [text5]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false,
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        padding: "60px",
        position: "relative",
      }}
    >
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "0px",
          right: "0px",
          margin: "auto",
          color: "white",
          width: "150px",
          height: "50px",
        }}
      >
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Beryliumrg, AphroditeSlimPro",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* PIERWSZY ALBUM */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#9f9590",
            position: "absolute",
            top: "64.1mm",
            left: "125mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Leosia */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#9f9590",
            position: "absolute",
            top: "95.1mm",
            left: "124.6mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontVariantLigatures: "no-contextual",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Kubusiu, jak się pisze MIŁOŚĆ? */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#9f9590",
            position: "absolute",
            top: "283mm",
            left: "124.7mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Prosiaczku, MIŁOŚĆ się nie pisze, */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font1,
            color: "#9f9590",
            position: "absolute",
            top: "296.9mm",
            left: "124.7mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* MIŁOŚĆ się czuje. */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font1,
            color: "#9f9590",
            position: "absolute",
            top: "311.1mm",
            left: "124.7mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/MD12.svg"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "2",
          }}
        />
      </div>
    </div>
  );
};
